import moment from "moment";
import { timeFilters } from "../../constants/asianTimeFilters";
import Config from "../../config/main";

export const getSportListSubscriptionRequest = (gameType, timeFilter, isForHashing) => {
    let req = {
        "source": "betting",
        "what": {"sport": ["id", "name", "alias", "order"], "game": "@count"},
        "where": {
            "game": {"@or": [{"type": {"@in": gameType === "prematch" ? [0, 2] : [1]}}, {"visible_in_prematch": 1}]},
            "sport": {"type": {"@in": [0, 2, 5]}}
        }
    };

    if (gameType === "esports") {
        req.where.sport = { "type": {"@in": [0]} };
        req.where.game = {
            "@or": [{"type": {"@in": [0, 1, 2]}}]
        };
    }
    if (Config.diableEsportsFromPrematchSection && gameType !== "esports") {
        req.where.sport = {
            "type": {"@in": [2, 5]}
        };
    }
    if (!isForHashing && timeFilter && !Config.enableDayFormatInPrematchLeftMenu && timeFilter !== 999) {
        req.where.game.start_ts = {
            '@now': {
                '@gte': Config.enableOneDayRangeFilterPrematch ? (timeFilter - 24) * 3600 : 0,
                '@lt': timeFilter * 3600
            }
        };
        if (timeFilter === 999 && Config.enableTodayButtonOnSport) {
            req.where.game = {
                "@or": [{"type": {"@in": [0, 2]}}, {"visible_in_prematch": 1}]
            };
        }
    }
    if (timeFilter === 0 && Config.enableTodayButtonOnSport) {
        let oneDayDate = moment().unix();
        req.where.game.start_ts = {
            '@gte': oneDayDate,
            '@lte': oneDayDate + 86400
        }
    } else if (!isForHashing && timeFilter && Config.enableDayFormatInPrematchLeftMenu && timeFilter !== 999) {
        var newDate = moment().startOf('day').unix() + timeFilter * 24 * 60 * 60;
        if (timeFilter === (-1)) {
            newDate = moment().startOf('day').unix() + 0 * 24 * 60 * 60;
        }
        req.where.game.start_ts = {
            '@gte': newDate,
            '@lt': newDate + 86400
        };
    }
    if (gameType === "today") {
        req.where.game = {
            "@or": [
                {
                    "start_ts": {
                        '@gte': moment().startOf("day").unix(),
                        '@lte': moment().endOf("day").unix()
                    },
                    "type": {"@in": [0, 2]}
                },
                { "visible_in_prematch": 1 }
            ]
        };
    }

    if (gameType === "topGames") {
        req.where.game = {
            "type": {"@in": [0, 2]},
            "promoted": true
        };
    }

    return req;
};
export const getSportTypeCount = (gameType, timeFilter) => {
    let req = {
        "source": "betting",
        "what": {"game": "@count"},
        "where": {
            "game": {"@or": [{"type": {"@in": gameType === "prematch" ? [0, 2] : [1]}}, {"visible_in_prematch": 1}]},
            "sport": {"type": {"@in": [0, 2, 5]}}
        }
    };
    if (gameType === "esports") {
        req.where.sport = { "type": {"@in": [0]} };
        req.where.game = {
            "@or": [{"type": {"@in": [0, 1, 2]}}]
        };
    }
    if (timeFilter === 999 && Config.enableTodayButtonOnSport) {
        req.where.game = {
            "@or": [{"type": {"@in": [0, 2] }}, {"visible_in_prematch": 1}]
        };
    }
    if (gameType === "prematch" && timeFilter === 0 && Config.enableTodayButtonOnSport) {
        let oneDayDate = moment().unix();
        req.where.game = {
            "@or": [
                {
                    "start_ts": {
                        '@gte': oneDayDate,
                        '@lte': oneDayDate + 86400
                    },
                    "type": {"@in": [0, 2]}
                }
            ]
        };
    }
    if (gameType === "today") {
        req.where.game = {
            "@or": [
                {
                    "start_ts": {
                        '@gte': moment().startOf("day").unix(),
                        '@lte': moment().endOf("day").unix()
                    },
                    "type": {"@in": [0, 2]}
                }
            ]
        };
    }

    if (gameType === "topGames") {
        req.where.game = {
            "type": {"@in": [0, 2]},
            "promoted": true
        };
    }
    return req;
};
const getTimeFilter = (from) => {
    for (let i = 0, length = timeFilters.length; i < length; i++) {
        if (timeFilters[i].from === from) {
            return timeFilters[i];
        }
    }
};

// export const getGameListSubscriptionRequest = (selectedSport, competitions, time, live, prematch, today, topGames) => {

//     let request = {
//         "source": "betting",
//         "what": {
//             "sport": ["id", "name", "alias"],
//             "competition": ["name", "alias", "order", "id"],
//             "region": ["name", "alias", "id"],
//             "game": ["id", "start_ts", "info"]
//         },
//         "where": {
//             "market": {
//                 "@or": [
//                     {
//                         "display_key": "ODD/EVEN"
//                     },
//                     {
//                         "display_key": "WINNER"
//                     },
//                     {
//                         "display_key": "HANDICAP",
//                         "main_order": {"@in": [1]}
//                     },
//                     {
//                         "display_key": "TOTALS",
//                         "main_order": {"@in": [1]}
//                     }
//                 ]
//             },
//             "game": {
//                 "@and": (prematch || today || topGames)      if you want to use this method, remove depricated @and operator
//                     ? [
//                         {
//                             "@or": [
//                                 {"type": {"@in": [0, 2]}},
//                                 {"visible_in_prematch": 1}
//                             ]
//                         },
//                         {
//                             "@or": time && time.reduce((collected, filter) => {
//                                 let currentFilter = getTimeFilter(filter),
//                                     request = {
//                                         "start_ts": {
//                                             "@gte": currentFilter.from,
//                                             "@lt": currentFilter.to
//                                         }
//                                     };
//                                 if (currentFilter.to === Infinity) {
//                                     delete request.start_ts["@lt"];
//                                 }
//                                 collected.push(request);
//                                 return collected;
//                             }, [])
//                         }
//                     ]
//                     : [
//                         {
//                             "@or": [
//                                 {"type": {"@in": [0, 2]}},
//                                 {"visible_in_prematch": 1}
//                             ]
//                         }
//                     ]
//             },
//             "competition": {"id": {"@in": competitions}},
//             "sport": {"id": selectedSport.id}
//         }
//     };
//     if (today) {
//         request.where.game = {
//             "@or": [
//                 {
//                     "start_ts": {
//                         '@gte': timeFilters[0].from,
//                         '@lte': timeFilters[0].to
//                     },
//                     "type": { "@in": Config.main.disableLiveGamesInToday ? [0, 2] : [0, 1, 2] }
//                 }
//             ]
//         };
//     }
//     if (live) {
//         request.where.game = {type: 1};
//     }
//     return request;
// };